import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export const CollapsibleSectionHeader = ({ 
  title, 
  icon: Icon, 
  isExpanded, 
  onToggle, 
  bgColor = 'bg-slate-100',
  textColor = 'text-slate-800',
  borderColor = 'border-slate-200',
  accentColor = 'bg-slate-500'
}) => {
  return (
    <div className={`mb-3 rounded-2xl overflow-hidden transition-all duration-300 ${isExpanded ? 'shadow-lg ring-2 ring-opacity-20' : 'shadow-sm hover:shadow-md'} ${isExpanded ? borderColor.replace('border-', 'ring-') : ''}`}>
      <button
        type="button"
        onClick={onToggle}
        className={`w-full flex items-center justify-between px-4 py-3.5 ${bgColor} ${textColor} transition-all duration-200 hover:brightness-95`}
      >
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-lg ${accentColor} bg-opacity-20 flex items-center justify-center transition-transform duration-200 ${isExpanded ? 'scale-110' : ''}`}>
            {Icon && <Icon className={`w-4 h-4 ${textColor}`} />}
          </div>
          <div className="flex flex-col items-start">
            <span className="text-sm font-bold tracking-wide">{title}</span>
            <span className="text-xs opacity-60">{isExpanded ? 'Click to collapse' : 'Click to expand'}</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-full ${isExpanded ? 'bg-white bg-opacity-50' : 'bg-white bg-opacity-30'} flex items-center justify-center transition-all duration-300`}>
            {isExpanded ? (
              <ChevronDown className="w-5 h-5 transition-transform duration-300" />
            ) : (
              <ChevronRight className="w-5 h-5 transition-transform duration-300" />
            )}
          </div>
        </div>
      </button>
    </div>
  );
};
